'use client';

import dynamic from 'next/dynamic';
import { FormServer } from './form-server';
import { ContactProps } from './type';

export default function FormWrapper({
  consent,
  variant,
  submitVariation,
  preppendForm,
  appendForm,
  className,
  appendMessage,
  sticky,
  fieldsPrefix = 'form',
}: ContactProps) {
  const FormClient = dynamic(() => import('./form-client'), {
    ssr: false,
    loading: () => (
      <FormServer
        consent={consent}
        variant={variant}
        submitVariation={submitVariation}
        preppendForm={preppendForm}
        appendForm={appendForm}
        appendMessage={appendMessage}
        className={className}
        sticky={sticky}
        fieldsPrefix={fieldsPrefix}
      />
    ),
  });

  return (
    <FormClient
      consent={consent}
      variant={variant}
      submitVariation={submitVariation}
      preppendForm={preppendForm}
      appendForm={appendForm}
      appendMessage={appendMessage}
      className={className}
      sticky={sticky}
      fieldsPrefix={fieldsPrefix}
    />
  );
}
